import { CONSTANTS } from "@/constants";
import {
  CreateSearchAlert,
  SavedSearchAlert,
} from "@/interfaces/search-alert.interface";
import { logger } from "../logger";

export const createSearchAlert = async (
  token: string,
  body: CreateSearchAlert
) => {
  const response = await fetch(`${CONSTANTS.API_URL}/search-alert`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    logger.error("Failed to create search alert");
    throw new Error("Failed to create search alert");
  }

  return response.json();
};

export const updateSearchAlert = async (
  token: string,
  id: string,
  body: Omit<CreateSearchAlert, "filters">
) => {
  const response = await fetch(`${CONSTANTS.API_URL}/search-alert/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    logger.error("Failed to update search alert");
    throw new Error("Failed to update search alert");
  }

  return response;
};

export const deleteSearchAlert = async (token: string, id: string) => {
  const response = await fetch(`${CONSTANTS.API_URL}/search-alert/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    logger.error("Failed to delete search alert");
    throw new Error("Failed to delete search alert");
  }

  return response;
};

export const fetchAllSearchAlerts = async (
  token: string
): Promise<Array<SavedSearchAlert>> => {
  const response = await fetch(`${CONSTANTS.API_URL}/search-alert`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    logger.error("Failed to get search alerts");
    throw new Error("Failed to get search alerts");
  }

  return await response.json();
};

export const unSubscribeSearchAlert = async (id: string, userId: string) => {
  const response = await fetch(
    `${CONSTANTS.API_URL}/search-alert/unsubscribe/${id}?userId=${userId}`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    logger.error("Failed to unsubscribe search alert");
    throw new Error("Failed to unsubscribe search alert");
  }

  return response;
};

export const unSubscribeAllSearchAlerts = async (userId: string) => {
  const response = await fetch(
    `${CONSTANTS.API_URL}/search-alert/unsubscribe-all/?userId=${userId}`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    logger.error("Failed to unsubscribe all search alerts");
    throw new Error("Failed to unsubscribe all search alerts");
  }

  return response;
};
